export function findVideoInPlayerWrapper(
    wrapper: HTMLElement | null,
): HTMLVideoElement | null {
    if (!wrapper) {
        return null;
    }
    const preferred = wrapper.querySelector(
        'video.hls-video',
    ) as HTMLVideoElement | null;
    if (preferred && preferred.videoWidth > 0) {
        return preferred;
    }
    const videos = wrapper.querySelectorAll('video');
    let largest: HTMLVideoElement | null = null;
    let largestArea = 0;
    videos.forEach((element) => {
        const video = element as HTMLVideoElement;
        const rect = video.getBoundingClientRect();
        const area = rect.width * rect.height;
        if (area > largestArea) {
            largestArea = area;
            largest = video;
        }
    });
    return largest;
}
